import type { PropsWithChildren } from "react";

import { EposContext } from "./context";
import { useEposDisplay } from "./use-epos-display";

export function EposContextProvider({ children }: PropsWithChildren<unknown>) {
	const context = useEposDisplay();

	return (
		<EposContext value={{ ...context }}>
			<>{children}</>
		</EposContext>
	);
}
